<template>
    <div class="p-3">
        <h4 class="text-dark">Control Center: User Permissions</h4>
        <table class="table table-striped mt-3">
            <thead>
                <tr class="border-top-none">
                    <td class="px-2">
                        Role
                    </td>
                    <td v-for="role in roles" :key="role.name" class="px-2 permissions-border-left">
                        {{ role.name }}
                    </td>
                </tr>
            </thead>
            <tbody v-if="roles.length">
                <template v-for="group in Object.keys(roles[0].permissions)">
                    <tr :key="group">
                        <td>
                            <span class="font-weight-bold text-uppercase text-nowrap">{{
                                group
                            }}</span>
                        </td>
                        <td v-for="_ in roles" class="px-2 permissions-border-left"></td>
                    </tr>
                    <template v-for="(permission, permissionIndex) in roles[0].permissions[group]">
                        <tr
                            v-if="!unavailablePermissionIds.includes(permission.id)"
                            :key="permission.id"
                        >
                            <td>
                                <span class="pl-3 text-nowrap"
                                    >{{ permission.name }}
                                    <i
                                        class="fa fa-info-circle text-info mx-2"
                                        v-if="permission.description"
                                        v-tooltip="{
                                            content: permission.description,
                                            classes: ['permission-description'],
                                        }"
                                    ></i>
                                </span>
                            </td>
                            <td
                                v-for="role in roles"
                                :key="role.id"
                                class="p-2 permissions-border-left"
                            >
                                <div
                                    class="h-100 p-2 d-flex justify-content-center align-items-center"
                                >
                                    <input
                                        type="checkbox"
                                        class="form-check"
                                        @change="togglePermission(role.id, group, permission.id)"
                                        :disabled="
                                            !role.permissions[group][permissionIndex].is_toggleable
                                        "
                                        v-model="
                                            role.permissions[group][permissionIndex].is_enabled
                                        "
                                    />
                                </div>
                            </td>
                        </tr>
                    </template>
                </template>
            </tbody>
        </table>
        <section class="alert-min-height">
            <transition name="simple-fade">
                <div v-show="alert.message" :class="`alert alert-${alert.class}`" role="alert">
                    {{ alert.message }}
                </div>
            </transition>
        </section>
    </div>
</template>

<script>
export default {
    name: "Permissions",
    props: {
        organization: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            roles: [],
            alert: {
                class: null,
                message: null,
            },
            platinumPermissions: [3, 14], //TODO: this should be moved to the permissions table
        };
    },
    created() {
        this.fetchPermissions();
    },
    computed: {
        unavailablePermissionIds() {
            if (!["professional_platinum"].includes(this.organization.type)) {
                return this.platinumPermissions; //TODO: this should be moved to the permissions table
            }
            return [];
        },
    },
    watch: {
        "alert.message"() {
            if (this.alert.message) {
                setTimeout(this.clearAlert, 5000);
            }
        },
    },
    methods: {
        clearAlert() {
            this.alert = {
                class: null,
                message: null,
            };
        },
        fetchPermissions() {
            axios
                .get(`/api/organizations/${this.organization.id}?with=roles`)
                .then(response => {
                    this.roles = response.data.roles;
                })
                .catch(e => {
                    console.error(e);
                    this.alert = {
                        class: "danger",
                        message: "An error occurred while loading the permissions table.",
                    };
                });
        },
        togglePermission(role_id, group, permission_id) {
            const payload = {
                role_id,
                permission_id,
            };
            axios
                .post(`/api/organizations/${this.organization.id}/toggle-permission`, payload)
                .then(response => {
                    this.roles
                        .find(role => role.id === role_id)
                        .permissions[group].find(
                            permission => permission.id === permission_id
                        ).is_enabled = response.data.data.is_enabled;
                    // Makes sure value reflects what's on DB
                    this.alert = {
                        class: "success",
                        message: "Changes saved.",
                    };
                })
                .catch(e => {
                    console.error(e);
                    this.alert = {
                        class: "danger",
                        message: "An error occurred while trying to save changes.",
                    };
                });
        },
    },
};
</script>

<style lang="scss">
.tooltip {
    &.permission-description {
        .tooltip-inner {
            font-size: 125%;
            text-align: left;
            line-height: 1.5;
            padding: 24px;
            min-width: 550px;
        }
    }
}
</style>
<style scoped lang="scss">
.permissions-border-left {
    border-left: solid 1px #bfbfbf;
}
.border-top-none {
    border-top: none;
}
.alert-min-height {
    min-height: 4rem;
}
</style>
